import {
  CLOSE_SNACKBAR,
  CommonActionTypes,
  FETCH_ERROR,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  SHOW_WARNING,
  TOGGLE_APP_DRAWER,
} from '../../types/actions/Common.action';

export const fetchSuccess = (): CommonActionTypes => ({type: FETCH_SUCCESS});

export const fetchError = (error: string): CommonActionTypes => ({
  type: FETCH_ERROR,
  error,
});

export const showError = (error: string): CommonActionTypes => ({
  type: FETCH_ERROR,
  error,
});

export const showMessage = (message: string): CommonActionTypes => ({
  type: SHOW_MESSAGE,
  message,
});

export const onToggleAppDrawer = (): CommonActionTypes => ({
  type: TOGGLE_APP_DRAWER,
});

export const closeSnackbar = (key: number) => ({
  type: CLOSE_SNACKBAR,
  payload: key,
});

export const showWarning = (message: string): CommonActionTypes => ({
  type: SHOW_WARNING,
  message,
});

export const hideMessage = (): CommonActionTypes => ({type: HIDE_MESSAGE});
